import { Box, Text } from '@mantine/core';
import { RedactionIconProps } from './types';
import { RedactEntity } from '@app/types/blackroom-api';
import {
  IconAddressBook,
  IconBuilding,
  IconCalendarEvent,
  IconCashBanknote,
  IconCreditCard,
  IconDeviceWatchStats2,
  IconHandStop,
  IconHash,
  IconLink,
  IconMail,
  IconPhone,
  IconUserSearch,
  IconUsers,
} from '@tabler/icons-react';
import { palette } from '@app/shared/ui-kit/colors';

export const getRedactionIcon = ({
  entity,
  size = 16,
  color = palette.blackroomLightGray2,
}: RedactionIconProps): React.ReactNode => {
  const entityIcons: Partial<Record<string, React.ReactNode>> = {
    bank_account_number: <IconCashBanknote size={size} color={color} />,
    company_id: <IconHash size={size} color={color} />,
    credit_card_number: <IconCreditCard size={size} color={color} />,
    email_address: <IconMail size={size} color={color} />,
    date: <IconCalendarEvent size={size} color={color} />,
    manual: <IconHandStop size={size} color={color} />,
    organization: <IconBuilding size={size} color={color} />,
    people: <IconUsers size={size} color={color} />,
    phone_number: <IconPhone size={size} color={color} />,
    postal_address: <IconAddressBook size={size} color={color} />,
    social_security_number: <IconUserSearch size={size} color={color} />,
    time: <IconDeviceWatchStats2 size={size} color={color} />,
    url: <IconLink size={size} color={color} />,
  } satisfies Record<Exclude<RedactEntity, 'keyword'>, React.ReactNode>;

  if (entity && entityIcons[entity]) {
    return entityIcons[entity];
  }

  return (
    <Box style={{ fontFamily: 'monospace', letterSpacing: '0.5px' }}>
      <Text fw="bold" c={color} fz={12}>
        KW
      </Text>
    </Box>
  );
};

export default function RedactionIcon(props: RedactionIconProps) {
  return getRedactionIcon(props);
}
